module.exports = __webpack_public_path__ + "static/media/gmp.4cf68127.png";